<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-if="!countriesFailed"
              v-model="defaultCountryId"
              :items="countryItems"
              item-text="title"
              item-value="id"
              label="Страна по умолчанию"
              hint="По ней тянутся города и улицы. Список берётся из CRM"
              persistent-hint
              dense
              outlined
              :rules="[rules.required]"
            ></v-select>
            <v-text-field
              v-else
              v-model="defaultCountryId"
              label="Страна по умолчанию"
              hint="CRM недоступна, список не загрузился — введите идентификатор вручную"
              persistent-hint
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'

export default {
  name: 'CrmSettingForm',
  data: () => ({
    rules,
  }),
  computed: {
    ...mapState('crmSetting', ['countries', 'countriesFailed']),

    countryItems() {
      return this.countries.map(x => ({ id: x.id, title: `${x.name} (${x.id})` }))
    },

    ...mapFormHandlers('crmSetting', [
      'defaultCountryId',
    ]),
  },
  async created() {
    await Promise.all([this.fetch(), this.fetchCountries()])
  },
  methods: {
    ...mapActions('crmSetting', ['update', 'fetch', 'fetchCountries']),
    cancel() {
      this.$router.back()
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update()
      }
    },
  },
}
</script>
